import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {BsModalService} from 'ngx-bootstrap/modal';
import {UtilsService} from '../../../core/services/utils/utils.service';
import {Entity} from '../../../core/models/entities/entity';
import {DashboardService} from '../../dashboard.service';
import {User} from '../../../core/models/user';
import {Router} from '@angular/router';

export interface Quote {
  createdAt: number;
  updatedAt: number;
  id: string;
  person_id: string;
  quoteBy: QuoteBy;
  type: string;
  famous_quote: string;
  status: string;
  byAdmin: boolean;
  addedBy: any;
}

export interface QuoteBy {
  name: string;
}

export interface Quote {
  person_id: string;
  type: string;
  famous_quote: string;
}

@Component({
    selector: 'app-banners',
    templateUrl: './add-quote.component.html',
    styleUrls: ['./add-quote.component.css'],
    standalone: false
})
export class AddQuoteComponent implements OnInit {

  loading = false;

  // Quotes
  quote = {person_id: null, type: 'Entity', famous_quote: ''};
  initialLookupEntities: Entity[];
  lookupEntities: Entity[];
  lookupUsers: User[];
  initialLookupUsers: User[];
  quotesData: any;
  quotes: Quote[] = [];
  keyword = '';
  option: string;

  constructor(private api: ApiService,
              private toastr: ToastrService,
              private modalService: BsModalService,
              private utils: UtilsService,
              private router: Router,
              private dashApi: DashboardService) {
  }

  ngOnInit(): void {
    this.getEntities();
    this.getUsers();
    this.getAllQuotes();
  }

  addQuote(): void {
    this.loading = true;
    this.api.addFamousQuote(this.quote).subscribe(res => {
      this.getAllQuotes();
      this.quote = {person_id: '', type: 'Entity', famous_quote: ''};
      this.loading = false;
      this.router.navigate(['/quotes']);
      this.utils.toastSuccess('New Quote added');
    }, err => {
      this.utils.resErr(err);
      this.loading = false;
    });
  }

  getEntities(isInitial = true): void {
    this.dashApi.searchEntities({keyword: this.keyword}).subscribe(res => {
      if (isInitial) {
        this.initialLookupEntities = res.response.entities;
      }
      this.lookupEntities = res.response.entities;
    }, err => this.utils.resErr(err));
  }

  handleInputChange(e, type = ''): void {
    const value = e.target.value;
    this.keyword = value;
    if (value.length > 2) {
      if (type === 'entity') {
        this.getEntities(false);
      } else {
        this.getUsers(false);
      }
    } else {
      if (type === 'entity') {
        this.lookupEntities = this.initialLookupEntities;
      } else {
        this.lookupUsers = this.initialLookupUsers;
      }
    }
  }

  getUsers(isInitial = true): void {
    this.api.getAllUsers({page: 1, per_page: 10, keyword: this.keyword}).subscribe(res => {
      this.lookupUsers = res.response.users;
      if (isInitial) {
        this.initialLookupUsers = res.response.users;
      }
    }, err => this.utils.resErr(err));
  }

  getAllQuotes(): void {
    this.api.getAllFamousQuote({keyword: ''}).subscribe(res => {
      const response = res?.response || {};
      this.quotesData = response;
      this.quotes = response.quotes || [];
      console.log('Quotes', this.quotes);
    }, err => this.utils.resErr(err));
  }

  deleteQuote(id): void {
    if (confirm('Are you sure you want to delete this quote?')) {
      this.api.deleteFamousQuote(id).subscribe(res => {
        this.getAllQuotes();
        this.utils.toastSuccess('Quote deleted!!');
      }, err => this.utils.resErr(err));
    }
  }

  updateQuoteStatus(id: string, status: string): void {
    this.api.quotesStatusUpdate({status, id}).subscribe(res => {
      this.getAllQuotes();
    }, err => this.utils.resErr(err));
  }
}
